import * as React from "react";
import { DQStageActivation } from "./DQStageActivation";
import { AppId } from "../../../../app/appTypes";
import { AKStageActivation } from "./AKStageActivation";
import { RAStageActivation } from "./RAStageActivation";
import { ValidationStageActivation } from "./ValidationStageActivation";
import { AksStageActivation } from "./AksStageActivationl";
import { URSStageActivation } from "./URSStageActivation";



export interface Stage {
    id: number;
    stage: string;
}

interface StageActivationRouterProps {
    open: boolean;
    stage: Stage | null;
    processId: AppId | null;
    structureId: number;
    processName?: string;
    processNumber?: string;
    deviceId?: string;
    onSuccess: (doc: any) => void;
    onCancel: () => void;
}

export const StageActivationRouter: React.FC<StageActivationRouterProps> = ({
    open,
    stage,
    processId,
    structureId,
    processName,
    processNumber,
    deviceId,
    onSuccess,
    onCancel,
}) => {  
    if (!open || !stage)
        return null;

    switch ((stage.stage ?? "").toString().toUpperCase()) {
        case "DQ":
            return (
                <DQStageActivation
                    processId={processId}
                    structureId={structureId}
                    processName={processName}
                    processNumber={processNumber}
                    deviceId={deviceId}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />
            );
        case "AC":
            return (
                <AKStageActivation
                    stageCode="AC"
                    processId={processId}
                    structureId={structureId}
                    processName={processName}
                    processNumber={processNumber}
                    deviceId={deviceId}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />
            );
        case "RA":
            return (
                <RAStageActivation
                    stageCode="RA"
                    processId={processId}
                    structureId={structureId}
                    processName={processName}
                    processNumber={processNumber}
                    deviceId={deviceId}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />
            );
        case "VALIDATION":
            return (
                <ValidationStageActivation
                    stageCode="VALIDATION"
                    processId={processId}
                    structureId={structureId}
                    processName={processName}
                    processNumber={processNumber}
                    deviceId={deviceId}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />
            );
        case "ACS":
            return (
                <AksStageActivation
                    stageCode="ACS"
                    processId={processId}
                    structureId={structureId}
                    processName={processName}
                    processNumber={processNumber}
                    validatedObjectName={""}
                    validatedObjectType={""}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />

            );
        case "URS":
            return (
                <URSStageActivation
                    stageCode="URS"
                    processId={processId}
                    structureId={structureId}
                    processName={processName}
                    processNumber={processNumber}
                    deviceId={deviceId}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />

            );

        default:
            return null;
    }
};
